import { Tab, TabList, tabsStyles } from '@creditflowresearch/uilib/Tabs';
import { CUSTOMIZATION_PANEL_TABS, type CustomizationPanelTabId } from './constants';

import styles from './customizationPanel.module.scss';

interface ICustomizationPanelTabsProps {
  activeTab: CustomizationPanelTabId,
  onTabChange: (tabId: CustomizationPanelTabId) => void,
  className?: string,
}

export const CustomizationPanelTabs = ({ activeTab, onTabChange, className }: ICustomizationPanelTabsProps) => (
  <div className={ className }>
    <TabList className={ styles.tabs } dataTest="customizationPanelTabs">
      { CUSTOMIZATION_PANEL_TABS.map((tab) => (
        <Tab
          key={ tab.id }
          tabFor={ tab.id }
          selected={ tab.id === activeTab }
          onClick={ () => onTabChange(tab.id) }
          name={ `${ tab.id }Tab` }
        >
          { tab.label }
        </Tab>
      )) }
    </TabList>
    <div className={ tabsStyles.tabsFooter } />
  </div>
);
